import type { FoaPart } from "../../../../../autogen/bff-api";

// These two helpers duplicate regulation constants that the BFF owns. Nothing breaks if they
// drift — the BFF still rejects a bad deadline — but the in-procedure tooltip and the summary
// footnote would silently mislead buyers. Keep them edited together with their BFF source:

// Mirrors StandstillRules.ELECTRONIC_STANDSTILL_DAYS / .daysFor:
// bff/domain/src/main/kotlin/no/sm/domain/domain/sourcingevent/v2/Standstill.kt
// Over-EØS procedures (Part III/IV) have a 10-day standstill (award notice is always delivered
// electronically); no standstill for other classifications.
export const autoKarensDays = (foaPart: FoaPart | null | undefined): number | null => {
  if (foaPart === "PART_III" || foaPart === "PART_IV") return 10;
  return null;
};

// Mirrors MIN_DEADLINE_DAYS_BY_PART:
// bff/bff/src/main/kotlin/no/sm/bff/domain/sourcingevent/v2/routes/SourcingEventV2Validation.kt
// Del II 25, Del III 30; other parts have no minimum.
export const minTenderDays = (foaPart: FoaPart | null | undefined): number | null => {
  if (foaPart === "PART_III") return 30;
  if (foaPart === "PART_II") return 25;
  return null;
};
